import { ChangeDetectorRef, Directive, OnDestroy, inject, input, linkedSignal } from '@angular/core';
import { ButtonsBarService } from '@ms/core';
import { ViewState } from '@ms/core/shared/viewstate';
import { LayoutService } from 'app/layout/layout.service';

@Directive()
export abstract class AbstractButtonBar<T = void> implements OnDestroy {
    layoutService = inject(LayoutService);
    buttonBarService = inject(ButtonsBarService);
    cdr = inject(ChangeDetectorRef);
    isMobile = linkedSignal<boolean>(() => this.layoutService.mobile());
    state = linkedSignal<ViewState>(() => this.buttonBarService.viewState);
    _fixed = false;
    open = false;
    spin = true;
    direction = 'up';
    animationMode = 'fling';
    data = input<any>(null);
    parent = input<T>(null);
    constructor() {}

    get fixed(): boolean {
        return this._fixed;
    }

    set fixed(fixed: boolean) {
        this._fixed = fixed;
        if (this._fixed) {
            this.open = true;
        }
    }

    ngOnDestroy() {}
}
